import { useState } from "react";
import { regenerateQAResume } from "services/candidates";

const useRegenerateQAResume = (candidateID) => {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const doRequest = async (qaResumeData) => {
    setIsLoading(true);

    const data = await regenerateQAResume({ candidateID, data: qaResumeData });
    setResponse(data);

    setIsLoading(false);
  };

  return { isLoading, response, doRequest };
};

export { useRegenerateQAResume };
